export default () => {
let commentsBlock = document.querySelector('.review-comments');
commentsBlock.style.height = commentsBlock.parentElement.offsetHeight + 'px';
commentsBlock.addEventListener('scroll', function() {
  if (commentsBlock.scrollTop + commentsBlock.offsetHeight >= commentsBlock.scrollHeight) {
  }
});
};